// extracted by mini-css-extract-plugin
export var planCard = "_v5-0";
export var planList = "_v5-1";